import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";

import { getAdminStoreState } from "@/stores";
import { Navbar } from "./-components";

const PrivateLayout = () => {
  return (
    <div className="flex min-h-screen flex-col bg-canvas md:flex-row">
      <Navbar />

      <main className="min-w-0 grow" id="main-content" tabIndex={-1}>
        <Outlet />
      </main>
    </div>
  );
};

export const Route = createFileRoute("/_private")({
  beforeLoad: ({ location }) => {
    const { token } = getAdminStoreState();

    if (!token) {
      throw redirect({ to: "/login", search: { redirect: location.href } });
    }
  },
  component: PrivateLayout,
});
